import React, { useState } from 'react';
import axios from 'axios';
import { Branding } from './Layout';

const ProfileEdit = ({ participant, token, onUpdate, onCancel }) => {
    const [facebook, setFacebook] = useState(participant.facebook || '');
    const [instagram, setInstagram] = useState(participant.instagram || '');
    const [photo, setPhoto] = useState(participant.photo || '');
    const [shareEmail, setShareEmail] = useState(participant.shareEmail ?? true);
    const [loading, setLoading] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const MAX_WIDTH = 400;
                const MAX_HEIGHT = 400;
                let width = img.width;
                let height = img.height;

                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
                setPhoto(dataUrl);
            };
            img.src = event.target.result;
        };
        reader.readAsDataURL(file);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.post('/speeddate/api/users/profile', {
                token: token || participant.token,
                facebook,
                instagram,
                photo,
                shareEmail
            });
            if (res.data.success) {
                window.Swal.fire({ title: 'Successo', text: 'Profilo aggiornato!', icon: 'success', confirmButtonColor: '#db2777' });
                onUpdate(res.data.participant);
            }
        } catch (err) {
            window.Swal.fire({ title: 'Errore', text: 'Impossibile aggiornare il profilo.', icon: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const fullName = `${participant?.firstName || ''} ${participant?.lastName || ''}`.trim() || 'Utente';

    return (
        <div className="card glass-premium border-0 p-4 p-md-5 mb-4 fade-in-up shadow-lg mx-auto" style={{ maxWidth: '500px', borderRadius: '45px' }}>
            <div className="text-center mb-4">
                <Branding />
                <h2 className="fw-900 text-dark mt-4 mb-2">Modifica Profilo</h2>
                <p className="text-muted fw-600 small">Personalizza il tuo profilo per farti conoscere meglio</p>
            </div>
            
            <div className="text-center mb-5">
                <div className="position-relative d-inline-block">
                    <div 
                        className="rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center overflow-hidden border" 
                        style={{ width: '150px', height: '150px', border: '4px solid white !important', boxShadow: '0 10px 25px rgba(219,39,119,0.2)' }}
                    >
                        {photo ? (
                            <img src={photo} alt="Profile" className="w-100 h-100 object-fit-cover" />
                        ) : (
                            <i className="fas fa-user fa-4x text-pink-200"></i>
                        )}
                    </div>
                    <label 
                        htmlFor="photo-upload" 
                        className="position-absolute bottom-0 end-0 bg-pink-600 text-white rounded-circle d-flex align-items-center justify-content-center shadow-lg transition-all hover-scale"
                        style={{ width: '45px', height: '45px', cursor: 'pointer', border: '3px solid white' }}
                    >
                        <i className="fas fa-camera"></i>
                    </label>
                    <input id="photo-upload" type="file" className="d-none" accept="image/*" onChange={handleFileChange} />
                </div>
                <div className="mt-3">
                    <h4 className="fw-900 mb-0 text-dark">{fullName}</h4>
                    <p className="text-pink-600 fw-700 small mb-0">{participant.email}</p>
                </div>
            </div>

            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label className="form-label small fw-900 text-muted ls-lg ms-2 text-uppercase">Profilo Instagram</label>
                    <div className="input-group input-group-lg shadow-sm rounded-4 overflow-hidden">
                        <span className="input-group-text bg-white border-0 text-pink-600 pe-0 ps-4"><i className="fab fa-instagram"></i></span>
                        <input 
                            type="text" 
                            className="form-control border-0 bg-white ps-3 py-3 fw-600" 
                            placeholder="@username" 
                            value={instagram} 
                            onChange={(e) => setInstagram(e.target.value)} 
                            style={{ fontSize: '1rem' }}
                        />
                    </div>
                </div>
                
                <div className="mb-5">
                    <label className="form-label small fw-900 text-muted ls-lg ms-2 text-uppercase">Profilo Facebook</label>
                    <div className="input-group input-group-lg shadow-sm rounded-4 overflow-hidden">
                        <span className="input-group-text bg-white border-0 text-pink-600 pe-0 ps-4"><i className="fab fa-facebook"></i></span>
                        <input 
                            type="text" 
                            className="form-control border-0 bg-white ps-3 py-3 fw-600" 
                            placeholder="Link profilo o nome" 
                            value={facebook} 
                            onChange={(e) => setFacebook(e.target.value)} 
                            style={{ fontSize: '1rem' }}
                        />
                    </div>
                </div>

                <div className="mb-4 text-start">
                    <div className="form-check form-switch d-flex align-items-center gap-2">
                        <input 
                            className="form-check-input bg-danger border-danger" 
                            type="checkbox" 
                            role="switch" 
                            id="shareEmailSwitch" 
                            checked={shareEmail}
                            onChange={(e) => setShareEmail(e.target.checked)}
                            style={{ cursor: 'pointer', transform: 'scale(1.3)' }}
                        />
                        <label className="form-check-label fw-700 text-dark ms-2" htmlFor="shareEmailSwitch" style={{ cursor: 'pointer' }}>
                            Condividi la mia email con i match
                        </label>
                    </div>
                </div>

                <div className="d-flex flex-column gap-3">
                    <button 
                        type="submit" 
                        className="btn btn-lg w-100 text-white fw-900 shadow-lg py-3" 
                        style={{ borderRadius: '25px', background: 'linear-gradient(45deg, #db2777, #f43f5e)', border: 'none', fontSize: '1.1rem' }} 
                        disabled={loading}
                    >
                        {loading ? <><i className="fas fa-spinner fa-spin me-2"></i> SALVATAGGIO...</> : 'SALVA MODIFICHE'}
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-lg btn-light w-100 fw-900 py-3 text-muted" 
                        style={{ borderRadius: '25px', background: 'rgba(0,0,0,0.03)', border: 'none', fontSize: '1.1rem' }} 
                        onClick={onCancel}
                    >
                        ANNULLA
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ProfileEdit;
